import { StyledToast } from "./style";
import React, { useEffect, useState } from "react";
import useToastStore from "store/useToastStore";
import _ from "lodash";
import { Util } from "Util";
import { CSSTransition } from "react-transition-group";
import "./animation.css";
import "./bottom-animation.css";
import {
  ToastButtonProps,
  ToastColor,
  ToastType,
} from "types/store/ToastStoreType";
import { ToastWrap } from "./toastWrap/ToastWrap";
import { FixedToastWrap } from "./toastWrap/FixedToastWrap";

export interface ToastListType {
  id: string;
  message: string;
  timeout: number;
  type: ToastType;
  color: ToastColor;
  button: ToastButtonProps | null;
  innerTitle?: string;
  innerMethod?: Function | null;
  closeMethod?: Function | null;
  loadingMessage?: string;
  visible: boolean;
}

export const Toast = () => {
  const [toastList, setToastList] = useState<ToastListType[]>([]);
  const {
    toastCloseTrigger,
    toastInstantClose,

    toastMessage,
    toastTimeout,
    toastType,
    toastColor,
    toastButton,
    toastCloseMethod,
    toastVisible,
    fixedToastType,
    fixedToastColor,
    fixedToastVisible,
    resetToast,
  } = useToastStore();

  const [isFixed, setIsFixed] = useState(false);

  const toastClose = (id: string) => {
    setToastList((prevToastList) => {
      return prevToastList.map((item) => {
        if (item.id === id) {
          if (item.closeMethod) item.closeMethod(); // 토스트 닫을 때 실행되어야 하는 메소드
          return { ...item, visible: false };
        } else return { ...item };
      });
    });
    setTimeout(() => setToastList([]), 500);
  };

  useEffect(() => {
    const toastId = Util.getRandomKey(16);
    const toastObject: ToastListType = {
      id: toastId,
      message: toastMessage,
      timeout: toastTimeout,
      type: toastType,
      color: toastColor,
      button: toastButton,
      closeMethod: toastCloseMethod,
      visible: toastVisible,
    };
    if (toastVisible) {
      setToastList((prevToastList) => {
        setTimeout(() => {
          setToastList((prevToastList) => {
            return prevToastList.map((item) => {
              if (item.id === toastId) {
                item = { ...item, visible: false };
              }
              return item;
            });
          });
        }, toastTimeout);
        return [toastObject, ...prevToastList];
      });
      resetToast();
    }
  }, [toastMessage, toastTimeout, toastType, toastVisible]);

  useEffect(() => {
    if (toastList.length) {
      if (!toastList.some((item) => item.visible)) {
        setTimeout(() => setToastList([]), 500);
      }
    }
  }, [toastList]);

  useEffect(() => {
    if (toastInstantClose) {
      setToastList([]);
    } else {
      setToastList(toastList.map((item) => ({ ...item, visible: false })));
    }
  }, [toastCloseTrigger, toastInstantClose]);

  useEffect(() => {
    if (fixedToastVisible) {
      setIsFixed(fixedToastVisible);
    } else if (!fixedToastVisible && fixedToastVisible !== isFixed) {
      setTimeout(() => {
        setIsFixed(fixedToastVisible);
      }, 500);
    }
  }, [fixedToastVisible]);

  return (
    <StyledToast $isFixed={isFixed}>
      {/* 고정형 TOAST 메시지 */}
      <CSSTransition
        unmountOnExit
        in={fixedToastVisible}
        timeout={500}
        classNames="toast-item"
      >
        <div
          id={toastList.length ? "test" : ""}
          className={`toast-box ${fixedToastType} ${fixedToastColor}`}
          style={{ zIndex: 1 }}
        >
          <FixedToastWrap />
        </div>
      </CSSTransition>

      {/* 타이머형 TOAST 메시지 */}
      {toastList.length > 0 &&
        toastList.map((toast, idx) => (
          <CSSTransition
            key={toast.id}
            in={toast.visible}
            timeout={500}
            classNames={fixedToastVisible ? "fixed-item" : "toast-item"}
            mountOnEnter
            unmountOnExit
          >
            <div
              className={`toast-box ${toast.type} ${toast.color} ${
                idx === 0
                  ? ""
                  : fixedToastVisible
                    ? "fade-fixed-item-enter-active"
                    : "fade-item-enter-active"
              }`}
            >
              <ToastWrap toast={toast} toastClose={toastClose} />
            </div>
          </CSSTransition>
        ))}
    </StyledToast>
  );
};
